import { useDispatch } from 'react-redux';
import { LocalizedText } from '@mews/framework';
import { Icon, IconName, List, ListItem } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useEnterpriseNavigate } from '@mews-commander/ui';
import { changeServiceId } from '@mews-commander/legacy-entities/src/ducks/serviceSelect';
import { getEnterpriseDefaultServiceId } from '@mews-commander/legacy-entities/src/selectors/enterpriseServices';
import { useCommanderSelector } from '@mews-commander/utils';
import { signOut } from '../../app/actions/common';
import { useLockMutation } from '../../auth/screens/SignInAndLockscreen/Lockscreen/useLockMutation';

export const UserMenuNavigationList = ({ onItemClick }: { onItemClick(): void }) => {
    const lockSession = useLockMutation();
    const dispatch = useDispatch();
    const navigate = useEnterpriseNavigate();

    const enterpriseId = useCurrentEnterpriseId();
    const defaultServiceId = useCommanderSelector((state) => getEnterpriseDefaultServiceId(state, { enterpriseId }));

    const handleProfileClick = async () => {
        onItemClick();
        await navigate({ to: 'Profile/Index' });
    };

    const handleSignOutClick = () => {
        onItemClick();
        dispatch(signOut());
        dispatch(changeServiceId(defaultServiceId));
    };

    const handleLockProfileClick = () => {
        onItemClick();
        lockSession();
    };

    return (
        <List>
            <ListItem
                value="Profile"
                primaryText={<LocalizedText textKey={TextKey.Account} />}
                onClick={handleProfileClick}
                leftIcon={<Icon value={IconName.Profile} />}
            />
            <ListItem
                value="Lock Session"
                primaryText={<LocalizedText textKey={TextKey.LockSession} />}
                onClick={handleLockProfileClick}
                leftIcon={<Icon value={IconName.Lock} />}
            />
            <ListItem
                value="Sign Out"
                primaryText={<LocalizedText textKey={TextKey.SignOut} />}
                onClick={handleSignOutClick}
                leftIcon={<Icon value={IconName.Logout} />}
            />
        </List>
    );
};
